import React, { useEffect, useState } from 'react';
import { dbDateToTimestamp, parseEntities, toLongDateDisplay, parseDateDesktopShort, today } from '../../utils/helpers';
import Tag from './Tag';
import AgendaIcon from '../svg/AgendaIcon';
import DateArrow from '../svg/DateArrow';
import { showTicketButtons, isFriendPage, canAccessFriendTickets } from '../../../../vriendenverkoop/vriendenverkoop';

const Card = ({ element, setTagsParam, config }) => {
	const [releaseDate, setReleaseDate] = useState('');
	const [endDate, setEndDate] = useState('');

	useEffect(() => {
		let startDate = null;
		let enddate = null;

		if ('date_range' in element && element.date_range[0]) {
			startDate = dbDateToTimestamp(element.date_range[0] + '0000');
		}
		if ('times' in element) {
			enddate = dbDateToTimestamp(element.times[0].program_end + '0');
		}

		// If the start date is in the past and there is an end date that >= today,
		// use today as start date
		if (startDate && enddate && startDate < today && enddate >= today) {
			setReleaseDate(today);
		} else if (startDate) {
			setReleaseDate(startDate);
		}

		if (enddate) {
			setEndDate(enddate);
		}
	}, []);

	useEffect(() => {
		if ('dates' in element && element.dates.release) {
			const date = dbDateToTimestamp(element.dates.release + '0000');
			// Haal einddatum op als die beschikbaar is
			let enddate = endDate;
			if (!enddate && 'times' in element) {
				enddate = dbDateToTimestamp(element.times[0].program_end + '0');
				if (enddate) {
					setEndDate(enddate);
				}
			}
				// Als de startdatum in het verleden ligt en er is een einddatum die >= vandaag is,
				// gebruik dan vandaag als startdatum
			if (enddate && date < today && enddate >= today) {
				setReleaseDate(today);
			} else {
				setReleaseDate(date);
			}
		}
	}, [endDate]);

	const friendType = element.friend_type;
	const onFriendPage = friendType && isFriendPage(friendType);

	useEffect(() => {
		if (onFriendPage) {
			showTicketButtons(friendType);
		}
	}, [onFriendPage, friendType]);

	const handleTagClick = (value, onlyActivate) => {
		setTagsParam(value, onlyActivate);
	};

	const friendLink = element.times[0]?.friend_link;
	const statusLabel = element.times[0]?.status_label;
	const canUseFriendTickets = Boolean(friendLink && canAccessFriendTickets(friendType));
	const isTicketsActive =
		canUseFriendTickets || Boolean(element.times[0]?.available && !friendLink);
	const cardHref = canUseFriendTickets ? friendLink : element.permalink;

	return (
		<div className="agenda-card-wrapper">
			<a className="agenda-card" href={cardHref}>
				<div className="agenda-card__header">
					<div className="agenda-card__img-container">
						<img
							loading="lazy"
							src={element.poster_mobile || element.poster_desktop}
							alt=""
							className="agenda-card__img"
						/>
					</div>
					<div className="agenda-card__content-faq">
						<div className="agenda-card__tags">
							{element.tags?.categories &&
								Object.keys(element.tags.categories).map((category, index) => (
									<Tag
										key={index}
										tagText={element.tags.categories[category]}
										displayIcon={false}
										classname="agenda-card__tag"
									/>
								))}
						</div>
						{releaseDate && (
							<time
								dateTime={toLongDateDisplay(parseDateDesktopShort(releaseDate))}
								className="agenda-card__date subtitle-small"
							>
								<AgendaIcon />
								<span className="subtitle-small agenda-card__date-text">
									{toLongDateDisplay(parseDateDesktopShort(releaseDate))}
								</span>
								{endDate && endDate !== releaseDate && (
									<>
										<DateArrow />
										<span className="subtitle-small agenda-card__date-text">
											{toLongDateDisplay(parseDateDesktopShort(endDate))}
										</span>
									</>
								)}
							</time>
						)}
					</div>
				</div>

				<div className="agenda-card__content">
					<div className="agenda-card__faq-m">
						<div className="agenda-card__tags">
							{element.tags?.categories &&
								Object.keys(element.tags.categories).map((category, index) => (
									<Tag
										key={index}
										tagText={element.tags.categories[category]}
										displayIcon={false}
										classname="agenda-card__tag"
									/>
								))}
						</div>
						{releaseDate && (
							<time
								dateTime={toLongDateDisplay(parseDateDesktopShort(releaseDate))}
								className="agenda-card__date subtitle-small"
							>
								<AgendaIcon />
								<span className="subtitle-small agenda-card__date-text">
									{toLongDateDisplay(parseDateDesktopShort(releaseDate))}
								</span>
								{endDate && endDate !== releaseDate && (
									<>
										<DateArrow />
										<span className="subtitle-small agenda-card__date-text">
											{toLongDateDisplay(parseDateDesktopShort(endDate))}
										</span>
									</>
								)}
							</time>
						)}
					</div>

					<h2 className="agenda-card__title">{parseEntities(element.title)}</h2>

					<div className="agenda-card__time-place">
						<p className="time__text subtitle-small">
							{`${element.times[0].program_start.substring(8, 10)}:${element.times[0].program_start.substring(10, 12)} uur -\u00A0`}
						</p>
						<p className="location subtitle-small">
							{Object.values(element.times[0].location)[0]}
						</p>
					</div>
				</div>

				<div
					className={`agenda-card__button${isTicketsActive ? '' : ' agenda-card__button--inactive'}`}
				>
					<p
						className={`agenda-card__button-text label${isTicketsActive ? '' : ' agenda-card__button-text--inactive'}`}
					>
						{isTicketsActive ? 'tickets' : statusLabel}
					</p>
				</div>

				<div className="grd-corner --no-fill">
					<div className="grd-corner-line"></div>
					<svg
						className="grd-corner-svg"
						width="84"
						height="22"
						viewBox="0 0 84 22"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M81 3L66.9436 11.8503C58.4871 17.1748 48.6976 20 38.7045 20H32.5H2"
							stroke="url(#paint0_linear_27_2)"
							strokeWidth="3"
							strokeLinecap="square"
						/>
						<defs>
							<linearGradient
								id="paint0_linear_27_2"
								x1="50.5"
								y1="19.9993"
								x2="-819"
								y2="-229.501"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="white" stopOpacity="0.2" />
								<stop offset="1" stopColor="white" stopOpacity="0" />
							</linearGradient>
						</defs>
					</svg>
				</div>
			</a>
		</div>
	);
};

export default Card;
